import React, { useEffect, useState } from 'react';
import { useLocation, Routes, Route } from 'react-router-dom';
import Main from './Main';
import Detalles from './Detalles';
import PoliticaPrivacidadPage from './PoliticaPrivacidadPage';
import { DEFAULT_FILTER, ArcFiltros } from './Main/SesionApp';

const App: React.FC = () => {
  const location = useLocation();
  const [indicador, setIndicador] = useState<string>('');

  // Función para leer query params
  const getQueryParams = () => {
    return new URLSearchParams(location.search);
  };

  useEffect(() => {
    const queryParams = getQueryParams();
    const showDetails = queryParams.get('details');
    const id = queryParams.get('id'); // si también tienes un `id`
    if (showDetails === 'true' && id) {
      
     var indicadorParam = {
        tipoClasificador: queryParams.get('tipoClasificador') || '',
        tipoValor: queryParams.get('tipoValor') || '',
        idVariable: queryParams.get('idVariable') || '',
        codigo: queryParams.get('idVariable') || '',
        indicador: queryParams.get('indicador') || '',
        sector: queryParams.get('sector') || '',
        entidad: '',
        anio: parseInt(queryParams.get('anio') || '2026'),
        meta: 0,
        avancePeriodo: 0,
        avanceDesagregacion: 0,
        unidadMedida: '',
        fechaReporte: '',
        esPDET: false,
        esFichaDepartamental: true,
        id: queryParams.get('idVariable') || '',
        capaPDETActiva: '',
        codigoDivipolaDpto: '',
        codigoDivipolaMpio: '',
        codigoDivipolaPdetRegion: '',
        internos: ''
      };

      var str = JSON.stringify(indicadorParam); // Convierte objeto a string
      setIndicador(str);
     


    }
  }, [location.search]);

  const handleToggleDetalles = (id: string) => {
    setIndicador(id);
  };

  const mostrarMain = indicador === '';
  const mostrarDetalles = !mostrarMain;

  return (
    <Routes>
      <Route
        path="/"
        element={
          <div style={{ height: "100vh", display: "flex", flexDirection: "column" }}>
            <div style={{ display: indicador === '' ? 'block' : 'none' }}>
              <Main onToggleDetalles={handleToggleDetalles} />
            </div>
            <div style={{ display: indicador !== '' ? 'block' : 'none' }}>
              <Detalles onToggleDetalles={handleToggleDetalles} indicador={indicador} />
            </div>
          </div>
        }
      />
      <Route path="/privacy" element={<PoliticaPrivacidadPage />} />
    </Routes>
  );
};

export default App;
